import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";
import { PersonaJuridicaSchema } from "./PersonaJuridicaSchema";
import { DestinoResiduoTratamiento } from "../utils/enums";

export const ResiduoTratamientoSchema = yup.object().shape({
  orden: yup.number().required("errors.residuoTratamiento.orden.required"),
  nombre: yup
    .string()
    .max(100, "errors.residuoTratamiento.nombre.max")
    .required("errors.residuoTratamiento.nombre.required")
    .default(""),
  cantidad: CantidadSchema.required(
    "errors.residuoTratamiento.cantidad.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3ANIO" } }),
  descripcion: yup
    .string()
    .max(1024, "errors.residuoTratamiento.descripcion.max")
    .required("errors.residuoTratamiento.descripcion.required")
    .default(""),
  destino: yup
    .object()
    .required("errors.residuoTratamiento.destino.required")
    .default(null),
  conPeligrosidad: yup
    .boolean()
    .required("errors.residuoTratamiento.conPeligrosidad.required")
    .default(false),
  transportista: yup
    .object()
    .concat(PersonaJuridicaSchema)
    .when(
      ["conPeligrosidad", "destino"],
      ([conPeligrosidad, destino], schema) =>
        conPeligrosidad || destino?.codigo !== DestinoResiduoTratamiento.EXTERNO
          ? schema.optional().nullable().default(null)
          : schema
              .required("errors.residuoTratamiento.transportista.required")
              .default(
                PersonaJuridicaSchema.cast(undefined, { assert: false }),
              ),
    ),
  tratador: yup
    .object()
    .concat(PersonaJuridicaSchema)
    .when(
      ["conPeligrosidad", "destino"],
      ([conPeligrosidad, destino], schema) =>
        conPeligrosidad || destino?.codigo !== DestinoResiduoTratamiento.EXTERNO
          ? schema.optional().nullable().default(null)
          : schema
              .required("errors.residuoTratamiento.tratador.required")
              .default(
                PersonaJuridicaSchema.cast(undefined, { assert: false }),
              ),
    ),
  frecuenciaRetiros: yup
    .object()
    .when(
      ["conPeligrosidad", "destino"],
      ([conPeligrosidad, destino], schema) =>
        conPeligrosidad || destino?.codigo !== DestinoResiduoTratamiento.EXTERNO
          ? schema.optional().nullable().default(null)
          : schema
              .required("errors.residuoTratamiento.frecuenciaRetiros.required")
              .default(null),
    ),
  tratamiento: yup
    .string()
    .max(1024, "errors.residuoTratamiento.tratamiento.max")
    .when(
      ["destino", "conPeligrosidad"],
      ([destino, conPeligrosidad], schema) => {
        if (
          !conPeligrosidad &&
          destino?.codigo === DestinoResiduoTratamiento.INTERNO
        ) {
          return schema.required(
            "errors.residuoTratamiento.tratamiento.required",
          );
        } else {
          return schema.optional().nullable();
        }
      },
    )
    .default(null),
});
